/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Creatorid2Inputs */

const de__field_creatorid2 = /** @type {(inputs: _Field_Creatorid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersteller-ID`)
};

/**

* @param {_Field_Creatorid2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_creatorid2 = /** @type {((inputs?: _Field_Creatorid2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Creatorid2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_creatorid2(inputs)
});
export { _field_creatorid2 as "_field_creatorID" }